import { useMemo, useState } from 'react';
import { useAuth } from '../providers/AuthContext';
import LegacyLoginWidget from './Login';
import LoginSsoFirst from './LoginSsoFirst';

function normalizeWidgetMode(raw) {
    const v = String(raw || '').trim().toLowerCase();
    if (v === 'legacy') return 'legacy';
    if (v === 'cilogon') return 'cilogon';
    return 'auto';
}

function isCilogonProvider(p) {
    const id = String(p?.id || '');
    const name = String(p?.name || '');
    return /cilogon/i.test(id) || /cilogon/i.test(name);
}

function LoginWidget(props) {
    const { oauth } = useAuth();
    const [modeOverride, setModeOverride] = useState(null); // 'legacy' | null

    const configuredMode = normalizeWidgetMode(import.meta.env.REACT_APP_LOGIN_WIDGET);
    const effectiveMode = modeOverride || configuredMode;

    const cilogonProvider = useMemo(() => (oauth || []).find(isCilogonProvider) || null, [oauth]);
    const hasCilogon = !!cilogonProvider;

    if (effectiveMode === 'legacy') {
        return <LegacyLoginWidget {...props} />;
    }

    if ((effectiveMode === 'cilogon' || effectiveMode === 'auto') && hasCilogon) {
        return (
            <LoginSsoFirst
                {...props}
                cilogonProvider={cilogonProvider}
                onUseLegacy={() => setModeOverride('legacy')}
            />
        );
    }

    // Fallback: either CILogon was requested but unavailable, or auto-detect found no CILogon.
    return <LegacyLoginWidget {...props} />;
}

export default LoginWidget;

